import Vue from 'vue'
import SvgIcon from './svg.vue'
import Empty from './Empty/index.vue'
import NavBar from './NavBar/index.vue'
import Loading from './Loading/index.vue'
import StatusBar from './statusBar/index.vue'
import travelMoney from './travelMoney/index.vue'
import zdyList from './zdyList/index.vue'
export default {
  install: (Vue) => {
    Vue.component('svg-icon', SvgIcon)
    Vue.component('empty', Empty)
    Vue.component('Loading', Loading)
    Vue.component('NavBar', NavBar)
    Vue.component('StatusBar', StatusBar)
    Vue.component('travelMoney', travelMoney)
    Vue.component('zdyList', zdyList)
  }
}